import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import type { Vendor } from "../../types/vendor";
import { getVendorsApi } from "../../api/vendorsApi";

interface VendorState {
  vendors: Vendor[];
  loading: boolean;
  error: string | null;
}

const initialState: VendorState = {
  vendors: [],
  loading: false,
  error: null,
};

export const fetchVendors = createAsyncThunk<Vendor[], void, { rejectValue: string }>(
  "vendors/fetchVendors",
  async (_, { rejectWithValue }) => {
    try {
      return await getVendorsApi();
    } catch (error: any) {
      return rejectWithValue(error.response?.data?.message || "Failed to fetch vendors");
    }
  },
);

const vendorSlice = createSlice({
  name: "vendors",
  initialState,
  reducers: {
    clearVendorsError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchVendors.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchVendors.fulfilled, (state, action: PayloadAction<Vendor[]>) => {
        state.loading = false;
        state.vendors = action.payload;
      })
      .addCase(fetchVendors.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Failed to fetch vendors";
      });
  },
});

export const { clearVendorsError } = vendorSlice.actions;
export default vendorSlice.reducer;
